import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DesignationService } from 'src/app/services/designation.service';
import { UserService } from 'src/app/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { WebConstants } from 'src/app/util/web.constants';
import { TokenStorage } from 'src/app/util/token.storage';
import { ToastrService } from 'ngx-toastr';
import { OrganizationService } from 'src/app/services/organization.service';
import { LookupService } from 'src/app/services/lookup.service';
import { Lookup } from 'src/app/model/lookup';
import { AuthenticationService } from "src/app/services/authentication.service";
import { threadId } from 'worker_threads';

@Component({
  selector: 'app-user-reset-dialog',
  templateUrl: './user-reset-dialog.component.html',
  styleUrls: ['./user-reset-dialog.component.scss']
})
export class ResetPasswordDialogComponent implements OnInit {
  public form: any;
  public roleList: Lookup[] = [];
  public adminRole: any;
  public orgId: number;
  public organizationList: Lookup[] = [];
  public isStatus: boolean;
  public currentUser: any;
  public isActiveUser: boolean;
  
  constructor(public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public organizationService: OrganizationService,
    public desingationsService: DesignationService,
    public userService: UserService,
    public tokenStorage: TokenStorage,
    public toastrService: ToastrService,
    public authenticationService: AuthenticationService,
    public lookupService: LookupService) {}

  ngOnInit() { 
    this.currentUser = this.tokenStorage.getUserId();
    this.initlizeUserResetForm();
    this.adminRole = this.authenticationService.currentUserValue.role;
    this.orgId = this.authenticationService.currentUserValue.organizationId;
    this.form.controls['firstName'].disable();
    this.form.controls['lastName'].disable();
    this.form.controls['emailAddress'].disable();
  }

  initlizeUserResetForm(): void {
    this.form = new FormGroup({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      emailAddress: new FormControl('', Validators.compose([Validators.required, Validators.email])),
      password: new FormControl('', Validators.required),
      confirmPassword: new FormControl('', Validators.required)
    });
    
    this.form.get('firstName').setValue(this.data.firstName);
    this.form.get('lastName').setValue(this.data.lastName);
    this.form.get('emailAddress').setValue(this.data.emailAddress);
  }

  resetPassword(): void{
    let resetData = this.form.getRawValue();
    if(resetData.password == resetData.confirmPassword){
      resetData.origin = WebConstants.ORIGIN;
      resetData.userId = this.data.userId;
      
      delete resetData.firstName;
      delete resetData.lastName;
      delete resetData.emailAddress;
      delete resetData.confirmPassword;

      this.userService.resetPassword(resetData)
      .pipe(first()).subscribe(response => {
        if (response && response.code === WebConstants.STATUS.CODE_SUCCESS) {
          this.toastrService.success(response.value, "Password Reset Successfully!");
          this.dialogRef.close(true);
        } else {
          this.toastrService.error(response.value, "Failed To Updated Data!");
        }
      })
    }
    else{
      this.toastrService.error("New Password and Confirm Password are not same");
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}